// ChallengeConditionsTable.tsx
import React from 'react';
import { Card, Typography } from '@mui/material';
import classes from './_buyChallenge.module.scss';

interface ChallengeConditionsTableProps {
  t: any;
  isDarkMode: boolean;
}

const ChallengeConditionsTable: React.FC<ChallengeConditionsTableProps> = ({
  t,
  isDarkMode,
}) => {
  return (
    <Card
      elevation={0}
      sx={{ padding: '16px', overflow: 'scroll' }}
      className={classes.conditions}
    >
      <h2>{t('challengeConditionsTable.challengeConditions')}</h2>

      <table
        className={`${classes.conditionTable} ${
          isDarkMode ? classes.dark : classes.light
        }`}
      >
        <thead className={classes.conditionTable__header}>
          <tr>
            <th></th>
            <th>{t('challengesCards.step')} 1</th>
            <th>{t('challengesCards.step')} 2</th>
            <th>{t('challengeConditionsTable.liveAccount')}</th>
          </tr>
        </thead>
        <tbody className={classes.conditionTable__body}>
          <tr>
            <td>{t('challengeConditionsTable.challengeDuration')}</td>
            <td>{t('challengeConditionsTable.unlimited')}</td>
            <td>{t('challengeConditionsTable.unlimited')}</td>
            <td>{t('challengeConditionsTable.unlimited')}</td>
          </tr>
          <tr>
            <td>{t('challengeConditionsTable.profitTarget')}</td>
            <td>10%</td>
            <td>5% </td>
            <td>-</td>
          </tr>
          <tr>
            <td>{t('challengeConditionsTable.maxDailyLoss')}</td>
            <td>5% </td>
            <td>5% </td>
            <td>5%</td>
          </tr>
          <tr>
            <td>{t('challengeConditionsTable.maxLoss')}</td>
            <td>10% </td>
            <td>10% </td>
            <td>10%</td>
          </tr>
          <tr>
            <td>{t('challengeConditionsTable.refundableFee')}</td>
            <td>{t('challengeConditionsTable.challengePrice')}</td>
            <td>{t('challengeConditionsTable.free')}</td>
            <td>{t('challengeConditionsTable.refund')}</td>
          </tr>
        </tbody>
      </table>
      <Typography fontSize={18} mt={2}>
        {t('challengeConditionsTable.ON_THE_FIRST_SCALE_UP')}
      </Typography>
    </Card>
  );
};

export default ChallengeConditionsTable;
